import { lazy } from 'react';
import { Path } from 'urlBuilder';

export default {
    path: Path.customFields,
    component: lazy(() => import(/* webpackChunkName: "custom-fields-page" */ './page')),
};
